import { render, staticRenderFns } from "./OptionalResources.vue?vue&type=template&id=bec4ede6&scoped=true"
import script from "./OptionalResources.vue?vue&type=script&lang=js"
export * from "./OptionalResources.vue?vue&type=script&lang=js"
import style0 from "./OptionalResources.vue?vue&type=style&index=0&id=bec4ede6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec4ede6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAvatar,VCheckbox,VProgressCircular,VTextField})
